export default "__VITE_ASSET__BX52bxKB__"